import React, {PureComponent} from 'react';
import {createMuiTheme, ThemeProvider} from '@material-ui/core/styles';
import {DateTimePicker, MuiPickersUtilsProvider} from '@material-ui/pickers';
import {getDatePickerProps} from '../helpers/Utils';
import JalaliUtils from '@date-io/jalaali';
import MomentUtils from '@date-io/moment';
import i18n from '../services/i18n';
import fa_IR from "../constants/locales";

class ReactTableDateFilter extends PureComponent {
  render() {
    const {selectedStartDate, selectedEndDate, handleDateChange, onChange} = this.props;
    return (
      <ThemeProvider theme={createMuiTheme({
        typography: {
          fontFamily: 'IRANSans',
        },
      })}>
        <MuiPickersUtilsProvider
          utils={i18n.language === fa_IR ? JalaliUtils : MomentUtils}
          locale={i18n.language}
        >
          <DateTimePicker
            {...getDatePickerProps()}
            value={selectedStartDate}
            TextFieldComponent={props => <input style={{width: '100%'}} placeholder={i18n.t('start date')} {...props} />}
            onChange={date => {
              handleDateChange('selectedStartDate', date);
              onChange(date);
            }}
          />
          <div style={{height: 4}} />
          <DateTimePicker
            {...getDatePickerProps()}
            value={selectedEndDate}
            TextFieldComponent={props => <input style={{width: '100%'}} placeholder={i18n.t('end date')} {...props} />}
            onChange={date => {
              handleDateChange('selectedEndDate', date);
              onChange(date);
            }}
          />
        </MuiPickersUtilsProvider>
      </ThemeProvider>
    );
  }
}

export default ReactTableDateFilter;